module.exports = __webpack_public_path__ + "img/worm-attack-mask-02.bdd8847a.png";